import { useEffect } from "react";
import { onMessage } from "firebase/messaging";
import { messaging } from "../lib/firebase";
import { useToast } from "../context/ToastContext";

/**
 * Zero-UI component. Registers a Firebase Messaging foreground listener once
 * on mount and tears it down on unmount. Must be rendered inside ToastProvider.
 *
 * Placed in App.js (not NotificationPrompt.js) so it is active on every page,
 * not just Home.
 */
const ForegroundNotificationHandler = () => {
  const { showToast } = useToast();

  useEffect(() => {
    let unsubscribe = null;

    const setup = async () => {
      try {
        const messagingInstance = await messaging;
        if (!messagingInstance) return; // browser doesn't support FCM

        unsubscribe = onMessage(messagingInstance, (payload) => {
          const title = payload.notification?.title ?? "Notification";
          const body = payload.notification?.body ?? "";
          const message = body ? `${title} — ${body}` : title;

          // persistent: true so the user has time to read it
          showToast(message, "info", true);
        });
      } catch (err) {
        console.warn("[ForegroundNotificationHandler] setup failed:", err);
      }
    };

    setup();

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default ForegroundNotificationHandler;
